import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import useInputObject from "../../hooks/useInputObject";
import { Checkbox, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import CommonAutocomplete from "../../components/CommonAutocomplete";

const infoTableCellSx = {
  fontSize: 17,
};

// 検索フォーム
function SearchForm(props) {
  const { buyers } = props;
  const searchForm = useInputObject({
    buyerNo: "",
    isHaveRemain: true,
  });
  const [buyer, setBuyer] = useState();

  useEffect(() => {
    searchForm.update("buyerNo", buyer?.buyerNo || "");
  }, [buyer]);

  useEffect(() => {
    props.search(searchForm.Value);
  }, [searchForm.Value]);

  return (
    <Box border="1px solid blue" borderRadius={1} padding={2}>
      フィルター
      <Box margin={2} marginBottom={1}>
        <Grid container alignItems="center" marginBottom={1} spacing={6}>
          <Grid item xs="auto">
            <CommonAutocomplete
              label="買人No"
              value={buyer || null}
              onSelect={(e, newValue) => {
                setBuyer(newValue);
              }}
              name="buyerNo"
              data={buyers}
              filterOptions={(options, { inputValue }) => {
                inputValue = inputValue.trim();
                return options.filter((x) => {
                  return (
                    x.buyerNo.toString().startsWith(inputValue) ||
                    x.buyerName.includes(inputValue)
                  );
                });
              }}
              optionLabel={(option) =>
                option ? option.buyerNo + " - " + option.buyerName : ""
              }
              width={500}
            />
          </Grid>
          {/* <Grid item xs="auto">
            取引先名:&nbsp;
            <OutlinedInput
              sx={{ width: 200 }}
              onChange={(e) =>
                searchForm.update("customerName", e.target.value)
              }
              value={searchForm.Value.customerName}
            />
          </Grid> */}
          <Grid item xs="auto">
            残がある:&nbsp;
            {/* <Checkbox checked={searchForm.Value.zan} onChange={(e)=>{}} /> */}
            <Checkbox
              checked={searchForm.Value.isHaveRemain}
              onChange={(e) => {
                searchForm.update("isHaveRemain", e.target.checked);
              }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          alignItems="center"
          justifyContent="flex-end"
          spacing={1}
        >
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={() => props.search(searchForm.Value)}
            >
              検索
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default SearchForm;
